module.exports = __webpack_public_path__ + "static/media/main.f67e972f.png";